import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@sainsburys-tech/fable'

import '../../sass/components/error-modal.scss'

const ErrorModal = (props) => {
  const {
    isOpen, title, details, handleClose
  } = props

  useEffect(() => {
    if (!isOpen) return undefined

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose()
      }
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [isOpen, handleClose])

  if (!isOpen) {
    return null
  }

  return (
    <div
      className="dsib-errorModalOverlay"
      aria-hidden="false"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          handleClose()
        }
      }}
    >
      <div
        className="dsib-errorModalDialog"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="dsib-errorModalHeader">
          <h2 className="dsib-errorModalTitle">{title}</h2>
          <button
            type="button"
            className="dsib-errorModalClose"
            aria-label="Close"
            onClick={handleClose}
          >
            ×
          </button>
        </div>
        <div className="dsib-errorModalBody">
          <p className="dsib-errorModalMessage">{details}</p>
          <div className="dsib-errorModalCta">
            <Button variant="primary" isFullWidth onClick={handleClose}>OK</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default ErrorModal
